<template lang="">
  <div class="common-layout">
    <top-bar :start="true" :task-content="state.answer" :task-title="state.partTitle" :default-duration="defaultDuration" :test-type="'Writing'" @handle-save-draft="handleSaveDraft" @handle-finish="handleFinish" />
    <el-row :gutter="16" style="margin-top:16px;">
      <el-col :span="11">
        <el-card :body-style="{ padding: '16px'}" style="height:calc(100vh - 114px);">
          <el-form ref="logFormRef" :model="logForm" label-width="80px" label-position="top">
            <el-form-item
              label="类型"
              prop="taskType"
            >
              <el-radio-group v-model="logForm.taskType" :disable="logForm.writingLogId!== undefined">
                <el-radio label="Task1" border />
                <el-radio label="Task2" border />
              </el-radio-group>
            </el-form-item>
            <el-form-item
              label="题目"
              prop="testContent"
            >
              <tinymce ref="editor" :value="testContent" :height="500" @changeContent="changeContent" />
            </el-form-item>
          </el-form>
        </el-card>
      </el-col>
      <el-col :span="13">
        <el-card :body-style="{ padding: '16px'}" style="height:calc(100vh - 114px);">
          <TaskTextArea :task="logForm.taskContent" :task-type="logForm.taskType" @on-input="onHandleAnswer" />
        </el-card>
      </el-col>
    </el-row>
    <el-dialog v-model="dialogFormVisible" width="60%" title="提交作文">
      <div class="date_title">请预约批改时间</div>
      <div class="date_subtitle">批改时间为最迟获得批改结果的时间，可预约5天之内的批改时间，每天0点开放新的可预约时间!</div>
      <ul class="dates">
        <li v-for="date in state.dates" :key="date.logDate">
          <template v-if="date.logDate >='2023-01-21' && date.logDate <='2023-01-29'">
            <div class="date disable">
              <span>{{ date.logDate }} </span>
              <span>暂停批改</span>
            </div>
          </template>
          <telmplate v-else>
            <div v-if="date.logCount > 0" class="date" :class="{'active': curDate === date.logDate}" @click="handleSelectDate(date.logDate)">
              <span>{{ date.logDate }} </span>
              <span>剩余可预约：<strong>{{ date.logCount }}</strong></span>
            </div>
            <div v-else class="date disable">
              <span>{{ date.logDate }} </span>
              <span>剩余可预约：<strong>{{ date.logCount }}</strong></span>
            </div>
          </telmplate>
        </li>
      </ul>
      <template #footer>
        <span class="dialog-footer">
          <el-button plain @click="dialogFormVisible = false">
            <font-awesome-icon icon="fa-solid fa-circle-xmark" style="margin-right:5px;" /> 取消
          </el-button>
          <el-button type="danger" plain @click="doFinish">
            <font-awesome-icon icon="fa-solid fa-cloud-arrow-up" style="margin-right:5px;" /> 提交作文
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script setup>
import { ref, reactive, onMounted, onUnmounted, nextTick } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { useStore } from 'vuex'

import { v4 as uuidv4 } from 'uuid'

import { ElMessage, ElMessageBox } from 'element-plus'

import { findWritingLog, saveWritingLog, findWrtingLogDates } from '@/apis/member'

import TopBar from './components/TopBar'
import TaskTextArea from './components/TaskTextArea'
import Tinymce from '@/components/Tinymce'

const dialogFormVisible = ref(false)
const testContent = ref('')

const partNum = uuidv4()

const state = reactive({
  task: undefined,
  partTitle: '自选题目:' + partNum,
  partId: undefined,
  typeId: undefined,
  answer: '',
  dates: []
})

const logForm = reactive({
  writingLogId: undefined,
  testPartId: undefined,
  testPartNum: undefined,
  testNote: '自选题目:' + partNum,
  testContent: undefined,
  taskType: 'Task1',
  taskContent: undefined,
  taskAttachment: undefined,
  taskNote: undefined,
  taskDuration: 0,
  deadline: undefined,
  status: '0',
  project: 'IELTS_TEST'
})

const store = useStore()

const route = useRoute()
const logId = route.query.logId || ''

const router = useRouter()

const defaultDuration = ref(0)
const curDate = ref(undefined)

onMounted(() => {
  // 监听浏览器返回
  window.addEventListener('popstate', goBack, false)

  nextTick(() => {
    // 禁用右键
    document.oncontextmenu = new Function('event.returnValue=false')
    // 禁用选择
    document.onselectstart = new Function('event.returnValue=false')
  })
})

onUnmounted(() => {
  window.removeEventListener('popstate', goBack)
})

const goBack = () => {
  ElMessageBox.confirm('确认结束本次作文写作？', '提示',
    {
      type: 'warning',
      confirmButtonText: '结束写作',
      cancelButtonText: '继续写作'
    }).then(() => {
    router.back()
  }).catch((action) => {
    if (action === 'cancel') {
      history.pushState(null, null, document.URL)
    }
  })
}

const fetchWritingLog = () => {
  findWritingLog(logId).then(res => {
    var _data = res.data.data
    logForm.writingLogId = _data.writingLogId
    logForm.testPartId = _data.testPartId
    logForm.testPartNum = _data.testPartNum
    logForm.testNote = _data.testNote
    logForm.testContent = _data.testContent
    logForm.taskType = _data.taskType
    logForm.taskContent = _data.taskContent
    logForm.taskNote = _data.taskNote
    logForm.taskDuration = _data.taskDuration
    logForm.status = _data.status
    defaultDuration.value = parseInt(_data.taskDuration || 0)
    testContent.value = _data.testContent
    state.partTitle = _data.testNote
  })
}

if (logId !== undefined && logId !== '') {
  fetchWritingLog()
}

const onHandleAnswer = (e) => {
  state.answer = e
  logForm.taskContent = e
}

const handleFinish = (time) => {
  if (logForm.testContent === undefined || logForm.testContent.length === 0) {
    ElMessage.error('题目不能为空!')
    return
  }

  if (logForm.taskContent === undefined || logForm.taskContent.length === 0) {
    ElMessage.error('提交的内容不能为空!')
    return
  }
  dialogFormVisible.value = true
  logForm.taskDuration = time
}

const doFinish = () => {
  if (curDate.value === undefined || curDate.value === '') {
    ElMessage.error('请选择预约批改时间！')
    return
  }
  ElMessageBox.confirm(
    '确认提交作文么？本次提交将扣除 1 个批改额度。',
    '温馨提示',
    {
      confirmButtonText: '确认提交',
      cancelButtonText: '再看看',
      type: 'warning'
    }
  )
    .then(() => {
      logForm.status = '1'
      logForm.deadline = curDate.value + ' 23:59:59'
      saveLog(logForm).then(res => {
        logForm.writingLogId = res.data.data.writingLogId
        ElMessage.success('提交作文成功，等待批改中!')
        store.dispatch('getWritingInfo')
        dialogFormVisible.value = false
        router.push({ path: '/writing', replace: true })
      })
    })
    .catch(() => {
      return
    })
}

const handleSaveDraft = (time) => {
  if (logForm.testContent === undefined || logForm.testContent.length === 0) {
    ElMessage.error('题目不能为空!')
    return
  }

  if (logForm.taskContent === undefined || logForm.taskContent.length === 0) {
    ElMessage.error('保存的内容不能为空!')
    return
  }
  logForm.status = '0'
  logForm.taskDuration = time
  logForm.deadline = undefined
  saveLog(logForm).then(res => {
    logForm.writingLogId = res.data.data.writingLogId
    ElMessage.success('保存草稿成功!')
  })
}

const saveLog = (form) => {
  return saveWritingLog(form)
}

const fetchDates = () => {
  findWrtingLogDates().then(res => {
    state.dates = res.data.data
  })
}
fetchDates()

const handleSelectDate = (v) => {
  curDate.value = v
}

const changeContent = (v) => {
  logForm.testContent = v
}
</script>
<style lang="scss" scoped>
.common-layout {
  background-color: #FFFFFF;
  min-height: 100vh;
  padding: 16px;
}

.date_title{
  font-weight: bold;
  font-size: 18px;
  color: #303133;
  margin-bottom: 8px;
}
.date_subtitle{
  font-size: 14px;
  color: #909399;
  margin-bottom: 16px;
}
ul.dates{
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  padding: 0;
  margin: 0;
  list-style:none;
  li{
    margin-right: 16px;
    div.date{
      display: inline-flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color:   #fef0f0;
      color: #F56C6C;
      border: 1px solid #F56C6C;
      border-radius: 4px;
      padding: 4px 16px;
      cursor: pointer;
      span:first-child{
        margin-bottom: 4px;
      }
      span strong{
        font-size: 16px;
      }
    }
    div.date:hover, div.date.active{
      background-color:#F56C6C;
      color:    #fef0f0;
    }
    div.date.disable{
      background-color:  #f4f4f5;
      color: #909399;
      border-color: #909399;
      cursor:auto;
    }
  }
}
</style>
